/**
 * Created by Mattias on 2014-10-09.
 */
define('payment/handlers/sendHandlers/externalPanelHandler',['jquery', 'payment/externalPanel'],

    function($, externalPanel) {
        'use strict';

        function init() {}

        function handleSuccessfulResponse(paymentBox, sendHandlerData, accHistRef, paymentFetchResultFlow) {
			var externalPanelInformation = (sendHandlerData.externalUrl !== undefined ? sendHandlerData : sendHandlerData.handler);
            externalPanel.openExternalPanel(paymentBox, externalPanelInformation);
        }

        function cleanupOnFail() {}

        var externalPanelDepositSendHandler = {};
        externalPanelDepositSendHandler.init = init;
        externalPanelDepositSendHandler.handleSuccessfulResponse = handleSuccessfulResponse;
        externalPanelDepositSendHandler.cleanupOnFail = cleanupOnFail;

        return externalPanelDepositSendHandler;
    }
);

